import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"instance-history"},[_c(VRow,[_c(VCol,[_c('h2',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('Schema.History')))])])],1),_c('app-change-log-timeline',_vm._b({on:{"action":_vm.showMore}},'app-change-log-timeline',{ changes: _vm.changes, showAction: _vm.showAction, loading: _vm.loading },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }